import React, { useEffect, useState } from 'react'
import { Container } from '@/components/container';
import { useToolbar } from '@/providers/ToolbarProvider';
import { useParams } from 'react-router';
import { KeenIcon, DefaultTooltip } from '@/components'

// PDF Viewer
import invoiceService from '@/services/billing/invoice/invoiceService';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { PDF_WORKER_URL } from '@/config/pdfViewer';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { toast } from 'sonner';

const InvoiceView = () => {
  const { token } = useParams();
  const { setConfig } = useToolbar();
  const [invoiceData, setInvoiceData] = useState(null)
  const [previewLoading, setPreviewLoading] = useState(false)
  const zoomPluginInstance = zoomPlugin();
  const { ZoomIn, ZoomOut, CurrentScale } = zoomPluginInstance;
  const [blobUrl, setBlobUrl] = useState(null);
  const [downlaodPdfLoading, setDownlaodPdfLoading] = useState(false)

  // Verify Token and fetch invoice PDF View and Data
  useEffect(() => {
    if (token) {
      (async () => {
        setPreviewLoading(true)
        try {
          const { data, status } = await invoiceService.verifyInvoiceToken(token);
          if (status) {
            setInvoiceData(data.invoice)
            setBlobUrl(data.pdf_base64)
          }
        } catch (err) {
          console.error('Error', err)
          toast.error('Invalid or Expired URL.', {
            description: 'Your invoice link is invalid or expired. Please try using a valid link.',
          });
        } finally {
          setPreviewLoading(false)
        }
      })();
    }
  }, [token]);

  const handleDwonlaod = async () => {
    setDownlaodPdfLoading(true)
    try {
      const blob = await invoiceService.previewInvoice(invoiceData.id, true);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `invoice-${invoiceData.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Failed to fetch invoice PDF', error);
      toast.error('Failed to dwonload.', {
        description: 'An error occurred while downloading invoice. Please try again later.',
      });
    } finally {
      setDownlaodPdfLoading(false)
    }
  }

  return (
    <Container>
      <div className="card min-w-full mb-4 h-[95vh]">
        <div className="card-header flex justify-between items-center">
          <h3 className="card-title">Invoice Preview</h3>
          <div className="flex items-center gap-2">
            <button className='btn btn-sm btn-light btn-outline' disabled={downlaodPdfLoading || previewLoading} onClick={handleDwonlaod}>
              <KeenIcon icon="exit-up" />
              {downlaodPdfLoading ? 'Please wait...' : 'Download PDF'}
            </button>
            <ZoomIn>
              {(props) => (
                <button
                  className="btn btn-xs btn-light"
                  onClick={props.onClick}
                  disabled={props.isDisabled}
                >
                  <KeenIcon icon="plus" />
                </button>
              )}
            </ZoomIn>
            <CurrentScale>
              {(props) => (
                <span className="text-xs"> {Math.round(props.scale * 100)}%</span>
              )}
            </CurrentScale>
            <ZoomOut>
              {(props) => (
                <button
                  className="btn btn-xs btn-light"
                  onClick={props.onClick}
                  disabled={props.isDisabled}
                >
                  <KeenIcon icon="minus" />
                </button>
              )}
            </ZoomOut>
          </div>
        </div>

        <div className="card-body">
          {previewLoading ? (
            <div className="text-center text-sm">Loading Preview...</div>
          ) : blobUrl ? (
            <div className='max-h-[630px] overflow-auto'>
              <Worker workerUrl={PDF_WORKER_URL}>
                <Viewer fileUrl={blobUrl} plugins={[zoomPluginInstance]} defaultScale={1} />
              </Worker>
            </div>
          ) : (
            <div className="text-center text-sm text-red-500">No preview available</div>
          )}
        </div>
      </div>
    </Container>
  );
};

export { InvoiceView }  